/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { BackButton } from '@/components/Buttons/BackButton';
import { ContentContainer } from '@/components/ContentContainer';
import { PageHeader } from '@/components/PageHeader';
import { QueryWrapper } from '@/components/QueryWrapper';
import { usePaginatedInstallerTokensQuery } from '@/hooks/query/usePaginatedInstallerTokensQuery';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { RevokedInstallerTokensTable } from '@/pages/InstallerTokens/RevokedInstallerTokensTable';
import { Container } from '@/primitives/Container';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export function RevokedInstallerTokensPage() {
  const tenantID = useMgmtPlaneStateStore((state) => state.selectedTenantID);
  const { t } = useMimicTranslation('installerTokens');

  const revokedTokensQuery = usePaginatedInstallerTokensQuery({
    type: 'queryParams',
    params: { filters: { revoked: true } },
  });

  if (!tenantID) return null;

  return (
    <ContentContainer width="100%">
      <Container full style={{ width: '100%' }}>
        <Container>
          <BackButton to={`/tenants/${tenantID}/installer-tokens`} label={t('backToInstallerTokens')} />
        </Container>
        <PageHeader title={t('revokedTokensTitle')} text={t('revokedTokensDescription')} level={2} />
        <QueryWrapper queryResult={revokedTokensQuery}>
          {(revokedTokensData) => (
            <RevokedInstallerTokensTable
              installerTokensData={revokedTokensData}
              updateQueryParams={revokedTokensQuery.updateQueryParams}
              installerTokenFilters={revokedTokensQuery.filters}
            />
          )}
        </QueryWrapper>
      </Container>
    </ContentContainer>
  );
}
